import { PageImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/pageImpression.trackingInfo";

import { EnrichedAnalyticsEvent } from "@/utils/analytics/analytics.types";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo
} from "../GoogleAnalyticsMinimumDataset";

export interface GoogleAnalyticsPageImpression
    extends GoogleAnalyticsMinimumDataset {}

const getGoogleAnalyticsPageImpression = (
    data: EnrichedAnalyticsEvent<PageImpressionTrackingInfo>
): GoogleAnalyticsPageImpression => {
    return {
        event: GoogleAnalyticsEvents.PageImpression,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data)
    };
};

export { getGoogleAnalyticsPageImpression };
